import { LoanInfosDto } from 'api/borrower';
import clsx from 'clsx';
import { BorrowerProjectDocumentsViewer } from 'features/subscription-process/components/BorrowerProjectDocumentsViewer';
import { useState } from 'react';
import { BorrowerProjectDocumentDto } from 'services/borrowerProjectDocumentsAPI';
import { BorrowerLoanForm } from './BorrowerLoanFormComponent';
import { useBorrowerLoanFormActions } from './useBorrowerLoanFormActions';

interface BorrowerLoanFormPanelProps {
  currentLoan?: LoanInfosDto;
  onSuccess: () => void;
  isRenego: boolean;
  /** Id du projet courant, figé depuis l'URL à l'ouverture du panneau (évite tout id périmé). */
  borrowerProjectId?: string;
  /** Project documents shown beside the form (loan offer, amortization schedule). */
  projectDocuments?: BorrowerProjectDocumentDto[];
}

export const BorrowerLoanFormPanel: React.FC<BorrowerLoanFormPanelProps> = ({
  currentLoan,
  onSuccess,
  isRenego,
  borrowerProjectId,
  projectDocuments
}) => {
  const {
    formikRef,
    initialValues,
    handleSubmit,
    handleValidationChange
  } = useBorrowerLoanFormActions({ currentLoan, onSuccess, borrowerProjectId });
  const [documentsCollapsed, setDocumentsCollapsed] = useState(false)

  const form = (
    <BorrowerLoanForm
      formikRef={formikRef}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onValidationChange={handleValidationChange}
      isRenego={isRenego}
    />
  );

  if (!projectDocuments?.some(d => d.storedFileId)) {
    return form;
  }

  return (
    <div className={clsx('flex gap-4', documentsCollapsed && 'flex-col')}>
      <BorrowerProjectDocumentsViewer
        documents={projectDocuments}
        collapsed={documentsCollapsed}
        onToggleCollapsed={() => setDocumentsCollapsed(collapsed => !collapsed)}
        // The panel body does not give its children a height: size the column on the viewport.
        className={documentsCollapsed ? undefined : 'sticky top-0 self-start w-[55%] h-[calc(100vh-12rem)] border-r pr-4'}
      />
      <div className="flex-1 min-w-0">{form}</div>
    </div>
  );
};
